import { createActions, createReducer } from 'reduxsauce'

import ItensPlanoService from '../../servicos/ItensPlanoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaItensPlanoInicio: [],
    buscaItensPlanoSucesso: ['itensPlano'],
    buscaItensPlanoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaItensPlano = filtro => {
    return dispatch => {
        dispatch(Creators.buscaItensPlanoInicio())
        let serv = new ItensPlanoService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaItensPlanoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaItensPlanoErro(error)))
    }
}

const buscaItensPlanoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaItensPlanoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaItensPlanoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.itensPlano, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ITENS_PLANO_INICIO]: buscaItensPlanoInicio,
    [Types.BUSCA_ITENS_PLANO_ERRO]: buscaItensPlanoErro,
    [Types.BUSCA_ITENS_PLANO_SUCESSO]: buscaItensPlanoSucesso,
})
